import { TenantPermission } from ".";
import RestrictedTenantRealm from "./RestrictedTenantRealm";
import TenantUsers from "./TenantUsers";

export default function AdminConsole() {
  return (
    <RestrictedTenantRealm
      requiredPermissions={[TenantPermission.ChangeTenantMemberPermissions]}
    >
      <TenantUsers />
    </RestrictedTenantRealm>
  );
}
